import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { BRAND } from '../../theme/brandTheme';

/**
 * Scrollable brand tabs for statistics page — syncs with ?brand= query param
 */
const StatisticsBrandTabs = ({ brands, selectedBrandId, onChange }) => {
  if (!brands?.length || brands.length <= 1) return null;

  const value = selectedBrandId || 'all';

  return (
    <Box sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={value}
        onChange={(_, next) => onChange(next === 'all' ? null : next)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="Marka filtreleri"
        sx={{
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            minHeight: 48,
            fontFamily: BRAND.fontFamily,
          },
          '& .Mui-selected': { color: `${BRAND.purple} !important` },
          '& .MuiTabs-indicator': { backgroundColor: BRAND.purple, height: 3 },
        }}
      >
        <Tab value="all" label="Tümü" />
        {brands.map((brand) => (
          <Tab key={brand._id} value={brand._id} label={brand.name} />
        ))}
      </Tabs>
    </Box>
  );
};

export default StatisticsBrandTabs;
